import { createStyles, makeStyles } from '@material-ui/core/styles';
import { variables } from './styles';

export const useStyles = makeStyles(() =>
  createStyles({
    success: {
      backgroundColor: variables.mediumSeaGreen,

      '& svg': {
        marginRight: 11,
      },

      '& svg path': {
        fill: variables.white,
      },
    },
    error: {
      backgroundColor: variables.americanPink,

      '& svg': {
        marginRight: 11,
      },
    },
    warning: {
      '& svg': {
        marginRight: 11,
      },
    },
    info: {
      '& svg path': {
        fill: variables.white,
      },

      '& svg': {
        marginRight: 11,
      },
    },
    btn: {
      boxShadow: 'none',
      borderRadius: '50%',
      padding: 7,
      minWidth: 24,
      width: 24,

      '& svg path': {
        fill: variables.white,
      },

      '&:hover': {
        backgroundColor: 'unset',
        opacity: '50%',
      },
    },
  }),
);
